import {
  saGlobalReleaseConstants,
  addSaGlobalReleaseConstants,
  editSaGlobalReleaseConstants,
} from "../_redux-constants";

export function saGlobalReleaseReducer(
  state = {
    saGlobalReleaseLoading: false,
    saGlobalReleaseData: null,
    saGlobalReleaseError: null,

    addSaGlobalReleaseLoading: false,
    addSaGlobalReleaseData: null,
    addSaGlobalReleaseError: null,

    editSaGlobalReleaseLoading: false,
    editSaGlobalReleaseData: null,
    editSaGlobalReleaseError: null,
  },
  action
) {
  switch (action.type) {
    case saGlobalReleaseConstants.SA_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        saGlobalReleaseLoading: true,
        saGlobalReleaseData: null,
        saGlobalReleaseError: null,
        addSaGlobalReleaseLoading: false,
        addSaGlobalReleaseData: null,
        addSaGlobalReleaseError: null,
      });
    case saGlobalReleaseConstants.SA_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        saGlobalReleaseLoading: false,
        saGlobalReleaseData: action.data,
      });
    case saGlobalReleaseConstants.SA_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        saGlobalReleaseLoading: false,
        saGlobalReleaseData: null,
        saGlobalReleaseError: action.error,
      });

    case addSaGlobalReleaseConstants.ADD_SA_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        addSaGlobalReleaseLoading: true,
        addSaGlobalReleaseData: null,
        addSaGlobalReleaseError: null,
      });
    case addSaGlobalReleaseConstants.ADD_SA_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        addSaGlobalReleaseLoading: false,
        addSaGlobalReleaseData: action.data,
      });
    case addSaGlobalReleaseConstants.ADD_SA_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        addSaGlobalReleaseLoading: false,
        addSaGlobalReleaseData: null,
        addSaGlobalReleaseError: action.error,
      });

    case editSaGlobalReleaseConstants.EDIT_SA_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        editSaGlobalReleaseLoading: true,
        editSaGlobalReleaseData: null,
        editSaGlobalReleaseError: null,
      });
    case editSaGlobalReleaseConstants.EDIT_SA_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        editSaGlobalReleaseLoading: false,
        editSaGlobalReleaseData: action.data,
      });
    case editSaGlobalReleaseConstants.EDIT_SA_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        editSaGlobalReleaseLoading: false,
        editSaGlobalReleaseData: null,
        editSaGlobalReleaseError: action.error,
      });

    default:
      return state;
  }
}
